export default "__VITE_ASSET__JoKqQKwU__"